<template>
  <div
    id="workflow-review-scrollable-content"
    ref="scrollableContent"
    style="overflow-x: hidden; position: relative"
    :style="heightAboveContainer"
    class="tw-overflow-y-scroll"
    @scroll="handleScroll"
  >
    <slot v-bind="{ observer, getScrollableRef }" />
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  props: {
    currentIndex: Number,
  },
  emits: ['item-focused', 'scroll'],
  data() {
    return {
      currentElement: null,
      observer: null,
      spaceAbove: 0,
    }
  },
  computed: {
    heightAboveContainer() {
      return {
        height: 'calc(100vh - ' + Math.round(this.spaceAbove + 1) + 'px)',
      }
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries.sort(
          (a, b) => b.intersectionRatio - a.intersectionRatio
        )[0]
        const isIntersecting = entry && entry.isIntersecting
        if (!isIntersecting) return

        this.currentElement = entry.target
        this.emitItemFocused(entry.target.dataset.index)
      },
      {
        root: this.$refs.scrollableContent,
        rootMargin: '-10% 0px -89.9% 0px',
        threshold: 0,
      }
    )

    nextTick(() => {
      this.spaceAbove = this.$refs.scrollableContent.getBoundingClientRect().top
    })
  },
  methods: {
    handleScroll(event) {
      this.$emit('scroll', event)
    },
    isScrolledIntoView(el) {
      const rect = el.getBoundingClientRect()
      const elemTop = rect.top
      const elemBottom = rect.bottom

      // Partially visible elements return true:
      const isVisible = elemTop < window.innerHeight && elemBottom >= 0
      return isVisible
    },
    emitItemFocused(index) {
      this.$emit('item-focused', parseInt(index))
    },
    getScrollableRef() {
      return this.$el
    },
  },
}
</script>
